export type TicketProgressBarTimeTextPlacement = 'top' | 'right' | 'hidden';

const TICKET_PROGRESS_BAR_TIME_TEXT_PLACEMENTS: ReadonlySet<TicketProgressBarTimeTextPlacement> = new Set([
    'top',
    'right',
    'hidden'
]);

export function isTicketProgressBarTimeTextPlacement(value: unknown): value is TicketProgressBarTimeTextPlacement {
    return (
        typeof value === 'string' &&
        TICKET_PROGRESS_BAR_TIME_TEXT_PLACEMENTS.has(value as TicketProgressBarTimeTextPlacement)
    );
}

export function resolveTicketProgressBarTimeTextPlacement(
    value: unknown,
    fallback: TicketProgressBarTimeTextPlacement = 'top'
): TicketProgressBarTimeTextPlacement {
    return isTicketProgressBarTimeTextPlacement(value) ? value : fallback;
}
